import { TextField, useTranslate } from 'react-admin';
import Detail from './Detail';

const Reason = () => {
  const translate = useTranslate();
  return (
    <Detail
      heading={translate('resources.incidents.fields.reason')}
      rows={[<TextField source="type.label" />]}
    />
  );
};

export default Reason;
